import React from 'react';
import { ImpButton, ImpFlex, ImpText, colors, ImpPad, ImpContainer, elevation, ImpIcon, zIndex, } from '../..';
import styled, { css } from 'styled-components';
import { ANIMATION_DURATION } from '../../DesignSystem/design-system';
const Container = styled(ImpContainer) `
  border-radius: 12px;
  transition: ${ANIMATION_DURATION} all;
  border: 1px solid;
  width: 100%;

  ${({ state }) => {
    switch (state) {
        case 'selected':
            return css `
          background-color: ${colors.surface.surfaceHigh};
          box-shadow: ${elevation.primary3};
          z-index: ${zIndex.selectedRedemption};
          border-color: var(--merchant-color);

          &:active {
            background-color: ${colors.surface.surfaceLow};
          }
        `;
        case 'disabled':
            return css `
          background-color: ${colors.background.backgroundDisabled};
          border-color: transparent;
          z-index: ${zIndex.defaultRedemption};

          p {
            color: ${colors.content.onBackgroundDisabled};
          }
        `;
        case 'enabled':
        default:
            return css `
          background-color: ${colors.surface.surfaceHigh};
          border-color: ${colors.border.borderVariant};
          z-index: ${zIndex.defaultRedemption};

          &:hover {
            background-color: ${colors.surface.surfaceMid};
          }

          &:active {
            background-color: ${colors.surface.surfaceLow};
          }

          p {
            color: ${colors.content.onBackgroundVariant};
          }
        `;
    }
}}
`;
export default function ImpRewardsButton({ state = 'enabled', iconSrc, title, subtitle, onClick, disabledOnClick, }) {
    const getButtonState = () => {
        if (state === 'disabled' && !disabledOnClick)
            return 'disabled';
        return 'enabled';
    };
    const getIconStroke = (state) => {
        if (state === 'disabled')
            return colors.content.onBackgroundDisabled;
        return 'var(--merchant-color)';
    };
    const handleButtonClick = () => {
        if (state === 'enabled')
            onClick === null || onClick === void 0 ? void 0 : onClick();
        else if (state === 'disabled')
            disabledOnClick === null || disabledOnClick === void 0 ? void 0 : disabledOnClick();
    };
    return (React.createElement(ImpButton, { state: getButtonState(), onClick: handleButtonClick, variant: "wrapper", size: "fill" },
        React.createElement(Container, { state: state, height: "100%" },
            React.createElement(ImpPad, { padding: "24px", mobilePadding: "16px" },
                React.createElement(ImpFlex, { direction: "column", align: "flex-start", gap: "l", fluid: true },
                    React.createElement(ImpIcon, { size: '32px', iconSrc: iconSrc, stroke: getIconStroke(state) }),
                    React.createElement(ImpFlex, { direction: "column" },
                        React.createElement(ImpText, { typography: "body2" }, title),
                        React.createElement(ImpText, { typography: "body3", color: colors.content.onBackgroundVariant }, subtitle)))))));
}
//# sourceMappingURL=ImpRewardsButton.js.map